<template>
  <zpa-row class="search-box" slot="search" height="auto">
    <zpa-form2 ref="Form" :label-width="labelWidth">
      <zpa-form-group inline style="padding-top: 10px;padding-bottom: -10px;padding-left: 10px;">
        <slot></slot>
        <!--        搜索按钮-->
        <zpa-row middle >
          <Button v-if="showSearchButton" type="primary" icon="ios-search" @click="onClickSearch" :size="buttonSize" style="margin-left: 0px;">搜 索</Button>
          <Button v-if="showSearchButton"  @click="onClickReset" icon="md-refresh" :size="buttonSize">重 置</Button>
          <Button v-if="showMore" @click="isActive=!isActive"  type="text" style="color:#40aaff;font-size: 14px;"><Icon type="ios-funnel" />高级筛选</Button>
          <slot  name="search"></slot>
        </zpa-row>
<!--        页面操作按钮-->
<!--        <zpa-row   style="margin-left: auto; align-self: center;" v-if="$slots.selfButton">-->
        <zpa-row   style="margin-left: auto; align-self: center;">
          <slot  name="selfButton"></slot>
<!--          <Button icon="md-settings" size ='large' style="margin-left: 5px;" title="设置显示列"/>-->
          <set-columns style="margin-left: 5px;" v-if="menuCode && columns && showConfig" :columns="columns" :menu-code="menuCode" />
        </zpa-row>

<!--          <moreSlideComponents>-->
<!--            <zpa-row v-show="isActive"  style="width: 100% !important;padding: 0px !important; margin-left: -10px;" class="moreSlideComponents">-->
<!--              <slot  name="hidden"></slot>-->
<!--            </zpa-row>-->
<!--          </moreSlideComponents>-->

<!--        <div style="position: absolute;bottom: -28px; width:calc(100vw - 220px); text-align: center " v-if="showMore">-->
<!--          <a  style="font-size: 18px; color:#2d8cf0; background-color: #FFFFFF;"-->
<!--              @click="isActive=!isActive">-->
<!--            <span v-if="!isActive">更多条件<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>-->
<!--            <span v-else>收起<i class="ivu-icon ivu-icon-ios-arrow-up"></i></span>-->
<!--          </a>-->
<!--        </div>-->

        <Drawer  :closable="true"  v-model="isActive" width="680px;" >
          <span slot="header" style="font-size: 16px"><Icon type="ios-funnel" />高级筛选</span>
          <span slot="close" style="font-size: 14px"> <Icon type="ios-arrow-dropright" />收起</span>
          <span class="llllllllll">
             <slot  name="hidden"></slot>
          </span>
          <Button type="primary" icon="ios-search" @click="onClickSearch" style="margin-left: 125px;" size="large">搜 索</Button>
          <Button  @click="onClickReset" icon="md-refresh" size="large">重 置</Button>

        </Drawer>

      </zpa-form-group>

    </zpa-form2>
  </zpa-row>
</template>

<script>
import moreSlideComponents from '@/zpa/moreSlideComponents'
import ZpaForm2 from '@/zpa/form/form-search-box'
import SetColumns from './SetColumns'

export default {

  name: 'SearchBox',
  components: {
    moreSlideComponents,
    ZpaForm2,
    SetColumns
  },
  data() {
    return {
      isActive: false
    }
  },
  inject: ['top', 'menuCode'],
  props: {
    primaryText: {
      type: String,
      default: '搜索',
    },
    buttonSize: {
      type: String,
      default: 'large',
    },
    labelWidth: {
      type: Number,
      default: 60
    },
    showSearchButton: {
      type: Boolean,
      default: true
    },
    // 是否显示 高级筛选
    showMore: {
      type: Boolean,
      default: false
    },
    // 控制显示列
    showConfig: {
      type: Boolean,
      default: false
    },
    columns: {type: Array, default: null} // table  列表
  },

  computed: {
    form() {
      return this.$refs['Form']
    },
  },

  methods: {
    onClickSearch() {
      this.isActive = false;
      this.$emit('search')
    },

    onClickReset() {
      this.$emit('reset')

      if (this.showMore && this.top) {
        this.$set(this.top, 'params', {})
      } else {
        this.$refs['Form'].reset()
      }
      // this.$refs['Form'].reset()
    },
  },
}
</script>

<style scoped lang="less">
  .search-box {
    padding: 0px !important;
    button {
      margin-right: 10px;
    }
  }

</style>
<style>
.moreSlideComponents .zpa-form-group .zpa-row .zpa-row .ivu-select .ivu-select-selection{
  width: 162px !important;
}
.llllllllll .zpa-form-group .zpa-row .zpa-row .ivu-select .ivu-select-selection{
  width: 162px !important;
}
.llllllllll .zpa-form-group .zpa-row .zpa-row .zpa-row .ivu-date-picker{
  width: 162px !important;
}
.example-header {
  font-weight: 500;
  margin: 30px 0 10px;
  position: relative;
}
</style>
